<template>
  <v-btn
    class="personal-area-btn"
    :prepend-icon="isAuth ? 'mdi-account' : 'mdi-login'"
    @click="gotoRoute"
    color="#F1F1F1"
    flat
    rounded="pill"
  >
    <div class="d-flex flex-column align-start ga-0">
      <span v-if="isAuth" class="welcom-msg">{{
        $t("Header.personalArea")
      }}</span>
      <span class="username">{{ isAuth ? userName : $t("Header.login") }}</span>
    </div>
  </v-btn>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    userName: {
      type: String,
    },
    isAuth: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions({
      setLoginModel: "AuthModule/setLoginModel",
      isUserGuest: "AuthModule/isUserGuest",
    }),
    gotoRoute() {
      if (this.isAuth) {
        this.$router.push("/account/orders");
      } else {
        this.setLoginModel(true);
      }
    },
  },
};
</script>

<style lang="scss">
.personal-area-btn {
  color: $iconColor;
  .welcom-msg {
    line-height: 1.3;
    letter-spacing: 0;
    font-size: 15px;
    font-weight: 300;
  }
  .username {
    line-height: 1.1;
    letter-spacing: 0;
    font-size: $mediumTextSize;
    font-weight: 700;
  }
  height: 52px !important;
  .v-icon {
    font-size: 28px !important;
  }
}
</style>
